import { render, staticRenderFns } from "./Guarantees.vue?vue&type=template&id=83ad799a&"
import script from "./Guarantees.vue?vue&type=script&lang=js&"
export * from "./Guarantees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports